import { render, staticRenderFns } from "./AssistantStep.vue?vue&type=template&id=3f9c66b1"
import script from "./AssistantStep.vue?vue&type=script&lang=ts"
export * from "./AssistantStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports